import { NetworkId } from '@kwenta/sdk/types'
import { formatNumber, truncateAddress } from '@kwenta/sdk/utils'
import { useCallback, useMemo } from 'react'
import { useNetwork } from 'wagmi'

import { EST_TRADE_TX_COST } from 'constants/defaults'
import { getBaseUrl } from 'containers/Connector/blockExplorer'
import {
	selectAbstractionBalance,
	selectAbstractionDelegated,
	selectSessionInfo,
	selectSessionValid,
} from 'state/futures/selectors'
import { useAppSelector } from 'state/hooks'
import { selectAbstractionAddress } from 'state/wallet/selectors'

export default function useAbstractionInfo() {
	const { chain } = useNetwork()

	const balance = useAppSelector(selectAbstractionBalance)
	const address = useAppSelector(selectAbstractionAddress)
	const truncatedAddress = truncateAddress(address ?? '')
	const sessionInfo = useAppSelector(selectSessionInfo)
	const isSessionActive = useAppSelector(selectSessionValid)
	const isDelegated = useAppSelector(selectAbstractionDelegated)

	const balanceString = useMemo(() => {
		return formatNumber(balance, { suggestDecimals: true })
	}, [balance])

	const openWallet = useCallback(() => {
		const chainId = (chain?.id as NetworkId) ?? 10
		const url = getBaseUrl(chainId)
		window.open(`${url}/address/${address}`, '_blank')
	}, [address, chain])

	const isLowBalance = useMemo(() => {
		return Number(balanceString) < EST_TRADE_TX_COST
	}, [balanceString])

	return {
		balanceString,
		address,
		truncatedAddress,
		openWallet,
		sessionInfo,
		balance,
		isSessionActive,
		isLowBalance,
		isDelegated,
	}
}
